import Color from 'color';
import { createGlobalStyle } from 'styled-components';
import { lFColor, lFColor0 } from 'pages/components/LFHeader/LFHeader.styled';

/** Shared .pagination purple — same tokens as ActivityLogs / Reporting chrome. */
export const PaginationThemeStyle = createGlobalStyle`
  .pagination .active .page-item-link,
  .pagination .active:hover .page-item-link {
    background: ${Color(lFColor0).alpha(0.12).toString()};
    border-color: ${Color(lFColor0).alpha(0.32).toString()};
    color: ${lFColor};
  }

  .pagination .page-item-link:focus-visible,
  .pagination .page-arrow-link:focus-visible {
    outline: 2px solid ${lFColor0};
    outline-offset: 1px;
  }
`;
